/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDefinitionKey { 
    /**
     * The name of a valid Namespace known by the system
     */
    namespace: string;
    /**
     * The name for this Business Object Definition
     */
    businessObjectDefinitionName: string;
}
